
import { Action, createReducer, on } from '@ngrx/store';
import { ISession } from '@interfaces/sesion.interface';
import { SessionActions } from './actions';
import { IClient } from '@interfaces/client.interface';

interface SessionState {
  user: ISession | null;
  error: string | null;
  loading: boolean;
  message: string | null;
}

const initialState: SessionState = {
  user: null,
  error: null,
  loading: false,
  message: null,
};
const featureReducer = createReducer(
  initialState,

  on(SessionActions.setUserSession, (state, { user }) => {
    return {
      ...updateFlags(state),
      user
    };
  }),

);

const updateFlags = (state: SessionState): SessionState => {
  return {
    ...state,
    error: null,
    loading: false,
    message: null,
  };
};
function reducer(state: SessionState | undefined, action: Action) {
  return featureReducer(state, action);
}
const getError = (state: SessionState) => state.error;
const getLoading = (state: SessionState) => state.loading;
const getMessage = (state: SessionState) => state.message;

const getUserSession = (state: SessionState) => state.user;


export const SessionUserReducer = {
  reducer,
  getError,
  getLoading,
  getMessage,
  getUserSession
}
export {
  SessionState
}
